import { FirstClassDocument } from '../../types';
import { isChunkedDocument } from '../../typeValidators';
import { isExtension } from '../../utils/environment';
import { usePartialDocument } from '../stateHooks';

export default (docId: FirstClassDocument['id'] | undefined): boolean => {
  if (isExtension) {
    return false;
  }

  const [doc] = usePartialDocument(docId, ['word_count', 'source_specific_data']);
  if (isChunkedDocument(doc)) {
    return false;
  }
  if (typeof doc?.word_count !== 'number') {
    return false;
  }
  return doc.word_count >= 1000;
};
